export const OidcConfiguration: Oidc.UserManagerSettings = {
	authority: process.env.REACT_APP_AUTHORITY_URL,
	client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,
	redirect_uri: process.env.REACT_APP_REDIRECT_URL,
	post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
	silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL,
	response_type: 'code',
	scope: 'openid profile SelfcareAppAPI.write SelfcareAppAPI.read networkId',
	automaticSilentRenew: true,
	loadUserInfo: true
};
